<template>
  <div class="layoutDefault" style="margin-top: 2rem">
    <div class="grid grid-cols-1 gap-4">
      <div class="z-10 flex items-center justify-between">
        <div class="flex cursor-pointer rounded-lg py-2" style="width: 50%" @click="$router.go(-1)">
          <IconArrow
            class="mr-3 mt-1 stroke-current text-habu h-6 w-6 stroke-2 transform rotate-0"
          />
          <span class="text-2xl text-normal">Instrument Report</span>
        </div>
        <div class="flex justify-end mt-3 space-x-3 w-1/2">
          <select
            v-model="selectedYear"
            class="p-1 bg-primary rounded-lg font-semibold text-white hover:bg-gray-300 hover:text-primary"
            style="height: auto"
          >
            <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
          </select>
          <a :href="iframeSrc + '&download=1'">
            <button
              class="px-3 py-1 bg-primary rounded-lg font-semibold text-white hover:bg-gray-300 hover:text-primary"
            >
              Download Report
            </button>
          </a>
        </div>
      </div>
      <div class="w-full flex flex-col justify-center items-center z-10 relative space-y-5">
        <iframe ref="reportIframe" :src="iframeSrc"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import IconArrow from '@/assets/icons/icon-arrow.svg?inline'

export default {
  name: 'InstrumentReport',
  components: {
    IconArrow
  },
  data() {
    const currentYear = new Date().getFullYear()
    return {
      years: [currentYear, currentYear - 1],
      selectedYear: currentYear - 1
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    iframeSrc() {
      const baseUrl = process.env.VUE_APP_URL_FCM
      const url = `${baseUrl}/dashboard/customer/${this.user.customer.data.uuid}?year=${this.selectedYear}`
      return url
    }
  },
  methods: {
    ...mapActions('instrument', ['GET_INSTRUMENT_REPORT']),
    async handleDownloadPDF() {
      try {
        const blobURL = await this.GET_INSTRUMENT_REPORT({ url: this.iframeSrc })
        const link = document.createElement('a')
        link.href = blobURL
        link.download = 'Instrument Report.pdf'
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (error) {
        console.error('Error downloading PDF:', error)
      }
    }
  }
}
</script>

<style scoped>
iframe {
  width: 850px;
  height: 100vh;
}
</style>
